




























































































































































































import api from "@/getinfo-api";
import { Vue, Component } from "vue-property-decorator";
import { Employee as IEmployee } from "@/api/models/employee";
import { ExpulsionOrder as IExpulsionOrder } from "@/api/models/expulsion-order";
import { ExpulsionOrderEdit as IExpulsionOrderEdit } from "@/api/models/expulsion-order-edit";
import ExpulsionOrderFormItemUsers from "@/components/expulsion/ExpulsionOrderFormItemUsers.vue";
import { isRoot } from "@/plugins/roles";
import CBreadCrumbs from "@/components/form/CustomPage/CBreadCrumbs.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import TextField from "@/components/form/CustomPage/textField.vue";
import EntityFiles from "@/components/fileManager/EntityFiles.vue";
import DocumentArchiveButton from "@/components/form/DocumentArchiveButton.vue";
import { generatePdf } from "@/utils/files-helper";
import { AxiosError } from "axios";
import {
  ErrorResponse as IErrorResponse,
  ValidationErrorResponse as IValidationErrorResponse
} from "@/api/models";
import DocTemplateGenerateV2 from "@/components/doc-tempates/DocTemplateGenerateV2.vue";

@Component({
  components: {
    DocTemplateGenerateV2,
    DocumentArchiveButton,
    EntityFiles,
    TextField,
    CBlock,
    CBreadCrumbs,
    ExpulsionOrderFormItemUsers
  }
})
export default class ExpulsionOrderView extends Vue {
  responsible!: IEmployee;
  showSpinner: boolean = false;
  expulsion!: IExpulsionOrder;
  sortVariable: string = "";
  isLoadingFiles: boolean = false;

  data() {
    return {
      expulsion: undefined,
      responsible: undefined
    };
  }

  async _generatePdf(file: any) {
    this.isLoadingFiles = true;
    const response = await generatePdf(file)
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        const { message } = err;
        this.$bvToast.toast(message, {
          variant: "danger",
          title: `${this.$tc(this.$translate.Error)}`
        });
      })
      .finally(() => {
        this.isLoadingFiles = false;
      });
    this.addFiles([response.id], true);
  }

  addFiles(files: any, fromDocTemplate: boolean = false) {
    let params: IExpulsionOrderEdit = {
      courseId: this.expulsion.courseId,
      signedAt: this.expulsion.signedAt,
      educationStartedAt: this.expulsion.educationStartedAt,
      educationFinishedAt: this.expulsion.educationFinishedAt,
      fileIds:
        this.expulsion.files && fromDocTemplate
          ? [...this.expulsion.files.map((el: any) => el.id), ...files]
          : [...files],
      number: this.expulsion.number,
      ownerId: this.expulsion.ownerId,
      listeners: this.expulsion.listeners.map((el: any) => el.id),
      formedAt: this.expulsion.formedAt
    };

    this.isLoadingFiles = true;

    api.ExpulsionOrderApi.edit(this.expulsion.id, params)
      .then((res: { data: IExpulsionOrder }) => {
        this.expulsion = res.data;
      })
      .finally(() => {
        this.isLoadingFiles = false;
      });
  }

  get breadcrumbs() {
    return [
      {
        to: { name: "expulsionList" },
        label: this.$tc(this.$translate.OrdersOfCompletion)
      },
      {
        label: this.expulsion.number
      }
    ];
  }

  get course() {
    return this.expulsion?.listeners?.[0]?.course;
  }

  get courseLink() {
    const v1 = { name: "courseView", params: { courseId: this.course?.id } };
    const v2 = { name: "course", params: { id: this.course?.id } };

    return this.course?.version === "v1" ? v1 : v2;
  }

  get isRoot() {
    return isRoot();
  }

  get status() {
    return !!this.expulsion?.signedAt;
  }

  sortListeners(sortItem: string) {
    this.sortVariable = sortItem;
    if (sortItem === "Тест") {
      this.expulsion.listeners.sort((x, y) => {
        return x.testCompleted === y.testCompleted
          ? 0
          : x.testCompleted
          ? -1
          : 1;
      });
    } else if (sortItem === "Практика") {
      this.expulsion.listeners.sort((x, y) => {
        return x.practiceCompleted === y.practiceCompleted
          ? 0
          : x.practiceCompleted
          ? -1
          : 1;
      });
    } else if (sortItem === "Обучение") {
      this.expulsion.listeners.sort((x, y) => {
        return x.status === y.status ? 0 : x.status === "success" ? -1 : 1;
      });
    }
  }

  async getExpulsion() {
    this.showSpinner = true;
    try {
      let getExpulsionResponse = await api.ExpulsionOrderApi.get(
        this.$route.params.expulsionId
      );
      this.expulsion = getExpulsionResponse.data;

      let getResponsibleResponse = await api.EmployeeApi.get(
        this.expulsion.companyId,
        this.expulsion.ownerId
      );
      this.responsible = getResponsibleResponse.data;
    } catch (err) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: err.response
      });
    } finally {
      this.showSpinner = false;
    }
  }

  created() {
    this.getExpulsion();
  }

  get screenWidth() {
    return window.innerWidth;
  }
}
